import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root'
})
export class ScheduledCampaign {
  private readonly http = inject(HttpClient);

  getScheduledCampaign(filters: any = {}): Observable<any> {
    return this.http.get<any>(`${environment.apiPrefix}${environment.message.scheduledCampaign}`, {
      params: filters
    });
  }

  downloadScheduledCampaign(filters: any = {}): Observable<Blob> {
    return this.http.get(
      `${environment.apiPrefix}${environment.message.downloadScheduledCampaign}`,
      {
        params: filters,
        responseType: 'blob'
      }
    );
  }

  deleteScheduledCampaign(id: string): Observable<any> {
    return this.http.delete<any>(
      `${environment.apiPrefix}${environment.message.deleteScheduledCampaign}/${id}`
    );
  }
}
